/**
 * Created by rak on 11/16/2017.
 */
'use strict';
angular.module('betosyswebapp')
  .controller('ImportDilaogCtrl', function ($scope, $uibModalInstance, $translate, telephoneService, toastService) {
    $scope.isImportBtnDisabled = true;

    $scope.fileChanged = function (element) {
      $scope.isFileinputDisabled = true;
      var file = element.files[0];
      var reader = new FileReader();
      $scope.isImportBtnDisabled = true;

      reader.onloadend = function (e) { //callback after files finish loading
        $scope.encodedData = e.target.result;
        $scope.isImportBtnDisabled = false;
        $scope.$apply();
        $scope.encodedData = $scope.encodedData.replace(/^data:text\/plain;base64,/, '');
        $scope.isFileinputDisabled = false;
        //here you can send data over your server as desired
      };
      reader.readAsDataURL(file);

    };

    $scope.close = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.import = function () {
      if ($scope.encodedData) {
        telephoneService.importTelephone($scope.encodedData).then(function () {
          $uibModalInstance.close($translate.instant('telephonesList.telephoneImport.successAlert'));

        }, function (response) {
          var _messsage = response.data && response.data.errors && response.data.errors[0].code ? $translate.instant('errorCodes.restAPI.' + response.data.errors[0].code + '.message') : response.data.message;
          var errorAlert = {type: 'F', message: _messsage};
          toastService.showErrorToast(errorAlert);
        });
      }

    };

  });



// WEBPACK FOOTER //
// ./.tmp/components/track/telephone/telephoneImportDialogController.js